import { render, staticRenderFns } from "./DrillPostList.vue?vue&type=template&id=6806109c"
import script from "./DrillPostList.vue?vue&type=script&lang=js"
export * from "./DrillPostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports